import type { Treatment, TreatmentCategory } from '../types/care';
import { injectionsHeadNeck } from './treatmentCatalog/injectionsHeadNeck';
import { injectionsTrunkLimbs } from './treatmentCatalog/injectionsTrunkLimbs';
import { nerveProcedures } from './treatmentCatalog/nerveProcedures';
import { infusionsAndDevices } from './treatmentCatalog/infusionsAndDevices';

export const treatmentCategories: TreatmentCategory[] = [
  'Injecties & blokkades',
  'Zenuwbehandelingen',
  'Infuus & medicatie',
  'Niet-invasief',
];

export const treatments: Treatment[] = [
  ...injectionsHeadNeck,
  ...injectionsTrunkLimbs,
  ...nerveProcedures,
  ...infusionsAndDevices,
].sort((a, b) => a.name.localeCompare(b.name, 'nl'));
